import React from "react";

export const ConditionalWrap = ({condition, wrap, children}) => condition ? wrap(children) : children;

